const curpRegex = /^[A-Z]{1}[AEIOUX]{1}[A-Z]{2}((\d{2}((0[13578]|1[02])(0[1-9]|[12][0-9]|3[01])|(0[13-9]|1[0-2])(0[1-9]|[12][0-9]|30)|02(0[1-9]|1[0-9]|2[0-8])))|([02468][048]|[13579][26])0229)[HM]{1}(AS|BC|BS|CC|CS|CH|CL|CM|DF|DG|GT|GR|HG|JC|MC|MN|MS|NT|NL|OC|PL|QT|QR|SP|SL|SR|TC|TS|TL|VZ|YN|ZS|NE)[B-DF-HJ-NP-TV-Z]{3}[0-9A-Z]{1}[0-9]$/i;
const rfcRegex = /^(([ÑA-Z|&]{3}|[A-Z]{4})\d{2}((0[1-9]|1[012])(0[1-9]|1\d|2[0-8])|(0[13456789]|1[012])(29|30)|(0[13578]|1[02])31)(\w{2})([A|0-9]{1}))$|^(([ÑA-Z|&]{3}|[A-Z]{4})([02468][048]|[13579][26])0229)(\w{2})([A|0-9]{1})$/i;

const validateCurp = (value) => (value && curpRegex.test(value));

const validateRfc = (value) => (value && rfcRegex.test(value));

const validateRfcOrCurp = (value) => (validateCurp(value) || validateRfc(value));

export { validateCurp, validateRfc, validateRfcOrCurp };
